export { default } from './Medal'
